import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import ImageUploading from "react-images-uploading";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Modal from "react-modal";
import SelectDropdown from "../../components-react/SelectDropdown";
import CustomizedDropzon from "../../components-react/CustomizedDropzon";
import {
  fetchAllUnitsData,
  fetchIngredientsData,
} from "../../../redux/reducers/apiSlice";
import {
  // mealCategories,
  ratingOptions,
} from "../../common-data/DropdowData";
import { createNewMeal } from "../../../redux/reducers/postApiSlice";
import { toast } from "react-toastify";
import { selectAuth } from "../../auth/auth.selector";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { updateMeal } from "../../../redux/reducers/putApiSlice";
import MultiSelect from "../../components-react/MultiSelect";
import { validateMealForm } from "../common/DPFormValidation";
import { fetchMealTimesData } from "../../../redux/reducers/dropdownApiSlice";
import IngForm from "../ingredients/IngForm";

const CreateMealForm = ({ closeModal, name, rowData, callFunction }) => {
  const dispatch = useDispatch();
  const { allUnitsData, ingData } = useSelector((state) => state.api);
  const { mealTimes } = useSelector((state) => state.dropdown);
  const { loading } = useSelector((state) => state.postApi);
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const mealInitials = {
    name: name === "edit" && rowData?.name ? rowData.name : "",
    selectedRating:
      name === "edit" && rowData?.rating
        ? {
            label: rowData.rating,
            value: rowData.rating,
          }
        : {
            label: "5",
            value: 5,
          },
    selectedCategory:
      name === "edit" && rowData?.category
        ? {
            label: rowData.category?.replace(/_/g, " "),
            value: rowData.category,
          }
        : "",
    selectedUnit:
      name === "edit" && (rowData?.unit_name || rowData?.unit_id)
        ? { label: rowData?.unit_name || "", value: rowData?.unit_id || "" }
        : "",
    protinGms:
      name === "edit" && rowData?.protien_grams ? rowData.protien_grams : "",
    protinCal:
      name === "edit" && rowData?.protien_cal ? rowData.protien_cal : "",
    carbsGms:
      name === "edit" && rowData?.carbs_grams ? rowData.carbs_grams : "",
    carbsCal: name === "edit" && rowData?.carbs_cal ? rowData.carbs_cal : "",
    fatGms: name === "edit" && rowData?.fat_grams ? rowData.fat_grams : "",
    fatCal: name === "edit" && rowData?.fat_cal ? rowData.fat_cal : "",
    totalCalories: name === "edit" && rowData?.cal ? rowData.cal : "",
    description:
      name === "edit" && rowData?.description ? rowData.description : "",
    method: name === "edit" && rowData?.method ? rowData.method : "",
    isActive: name === "edit" && rowData?.status === "active" ? true : false,
    isPopular: name === "edit" && rowData?.is_popular ? true : false,
    selectedIngredients:
      name === "edit" && rowData?.ingredients_data?.length > 0
        ? rowData.ingredients_data.map((ingredient) => ({
            label: ingredient.name,
            value: ingredient.uid,
          }))
        : [],
    ingredients: [{ id: Date.now(), selectedIngredient: "" }],
  };
  const [mealForm, setMealForm] = useState(mealInitials);
  const imgVdoInitials = {
    thumbnailImg:
      name === "edit" && rowData.thumbnail
        ? [{ data_url: rowData.thumbnail }]
        : [],
    coverImg:
      name === "edit" && rowData.co_image
        ? [{ data_url: rowData.co_image }]
        : [],
    video: name === "edit" && rowData.video ? [{ path: rowData.video }] : [],
  };
  const [mealFormImages, setMealFormImages] = useState(imgVdoInitials);

  const maxNumber = 1;
  const [mealFormErrors, setMealFormErrors] = useState({});
  const initialDropdown = {
    allUnits: [],
    allIngredients: [],
    mealCategories: [],
  };
  const [allDropdown, setAllDropdown] = useState(initialDropdown);
  const [isSubmit, setIsSubmit] = useState(false);
  const [ingModal, setIngModal] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, checked } = e.target;
    if (name === "protinGms") {
      setMealForm((prev) => ({
        ...prev,
        [name]: value,
        protinCal: (value * 4).toFixed(2),
      }));
    } else if (name === "carbsGms") {
      setMealForm((prev) => ({
        ...prev,
        [name]: value,
        carbsCal: (value * 4).toFixed(2),
      }));
    } else if (name === "fatGms") {
      setMealForm((prev) => ({
        ...prev,
        [name]: value,
        fatCal: (value * 9).toFixed(2),
      }));
    } else if (name === "isActive") {
      setMealForm((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else if (name === "isPopular") {
      setMealForm((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      setMealForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const onChangeTextInput = (content, fieldName) => {
    setIsSubmit(false);
    setMealForm((prev) => ({ ...prev, [fieldName]: content }));
  };

  const onChangeDropdown = (value, name) => {
    setMealForm({ ...mealForm, [name]: value });
  };

  const onChangeImages = (imageList, name) => {
    setIsSubmit(false);
    setMealFormImages((prevImages) => ({
      ...prevImages,
      [name]: imageList,
    }));
  };

  const handleVideoDrop = (acceptedFiles) => {
    setIsSubmit(false);
    setMealFormImages((prevImages) => ({
      ...prevImages,
      video: [...prevImages.video, ...acceptedFiles],
    }));
  };

  const onSubmit = () => {
    setMealFormErrors(validateMealForm(mealForm, mealFormImages));
    setIsSubmit(true);
  };

  const handleCreateNewMeal = async (requestBody, TOKEN) => {
    setIsSubmit(false);

    try {
      const actionResult =
        name === "edit"
          ? dispatch(updateMeal({ TOKEN, filters: "", requestBody }))
          : dispatch(createNewMeal({ requestBody, TOKEN }));
      const result = await actionResult;

      console.log("result=> ", result);

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleCreateNewMeal ERROR => ", error);
    }
  };

  useEffect(() => {
    if (mealForm.protinGms && mealForm.fatGms && mealForm.carbsGms) {
      const totals =
        (mealForm.protinGms * 4 || 0) +
        (mealForm.fatGms * 9 || 0) +
        (mealForm.carbsGms * 4 || 0);
      setMealForm((prev) => ({
        ...prev,
        totalCalories: parseFloat(totals || 0)?.toFixed(2),
      }));
    }
  }, [mealForm.protinGms, mealForm.fatGms, mealForm.carbsGms]);

  useEffect(() => {
    dispatch(
      fetchMealTimesData({
        token: decryptedText?.token,
        qps: "",
        pageNo: 1,
        limit: 1000,
      })
    );
  }, []);

  useEffect(() => {
    if (mealTimes) {
      setAllDropdown((prevs) => ({ ...prevs, mealCategories: mealTimes }));
    } else {
      setAllDropdown((prevs) => ({ ...prevs, mealCategories: [] }));
    }
  }, [mealTimes]);

  useEffect(() => {
    dispatch(
      fetchAllUnitsData({
        token: decryptedText?.token,
        pageNo: 1,
        limit: 100,
      })
    );

    dispatch(
      fetchIngredientsData({
        pageNo: 1,
        limit: 1000,
        queryParameters: "",
        token: decryptedText?.token,
      })
    );
  }, []);

  useEffect(() => {
    if (allUnitsData?.status && allUnitsData?.data?.length > 0) {
      const unitsData = allUnitsData?.data?.map((item) => ({
        value: item.uid,
        label: item.unit_name,
      }));
      setAllDropdown((prev) => ({ ...prev, allUnits: unitsData }));
    } else {
      setAllDropdown((prev) => ({ ...prev, allUnits: [] }));
    }

    if (ingData?.status && ingData?.data?.length > 0) {
      const ings = ingData?.data?.map((item) => ({
        value: item?.uid,
        label: item?.name,
      }));
      setAllDropdown((prev) => ({ ...prev, allIngredients: ings }));
    } else {
      setAllDropdown((prev) => ({ ...prev, allIngredients: [] }));
    }
  }, [allUnitsData, ingData]);

  useEffect(() => {
    if (isSubmit && Object.keys(mealFormErrors)?.length === 0) {
      const data = new FormData();

      data.append("name", mealForm.name);
      data.append("rating", mealForm.selectedRating?.value);
      data.append(
        "category",
        mealForm.selectedCategory?.label?.replace(/ /g, "_")?.toLowerCase()
      );
      data.append("cal", mealForm.totalCalories);
      data.append("description", mealForm.description);
      data.append("method", mealForm.method);
      data.append("fat_cal", mealForm.fatCal);
      data.append("fat_grams", mealForm.fatGms);
      data.append("protien_cal", mealForm.protinCal);
      data.append("protien_grams", mealForm.protinGms);
      data.append("carbs_cal", mealForm.carbsCal);
      data.append("carbs_grams", mealForm.carbsGms);
      data.append("unit_id", mealForm.selectedUnit?.value);
      data.append("is_popular", mealForm.isPopular ? 1 : 0);
      data.append("status", mealForm.isActive ? "active" : "inactive");
      data.append("is_new", 1);

      const ingredientsString = mealForm.selectedIngredients
        .map((ingredient) => ingredient?.value)
        .filter(Boolean)
        .join(",");

      data.append("ingredients", ingredientsString);

      mealFormImages.thumbnailImg?.forEach((img) => {
        data.append(
          `thumbnail`,
          img.file ? img.file : rowData?.thumbnail ? rowData.thumbnail : ""
        );
      });

      mealFormImages.coverImg?.forEach((img) => {
        data.append(
          `cover_image`,
          img.file ? img.file : rowData?.co_image ? rowData.co_image : ""
        );
      });

      mealFormImages.video?.forEach((vid) => {
        data.append(`video`, vid ? vid : rowData.video ? rowData.video : "");
      });

      if (name === "edit") {
        data.append("uid", rowData?.uid);
      }

      handleCreateNewMeal(data, decryptedText?.token);
    }
  }, [isSubmit, mealFormErrors]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <>
      <Modal
        isOpen={ingModal}
        onRequestClose={() => {
          setIngModal(false);
        }}
        contentLabel="Add Ingredient Modal"
        ariaHideApp={false}
      >
        <IngForm
          closeModal={() => setIngModal(false)}
          callFunction={() =>
            dispatch(
              fetchIngredientsData({
                pageNo: 1,
                limit: 1000,
                queryParameters: "",
                token: decryptedText?.token,
              })
            )
          }
        />
      </Modal>

      <div className="createNewCTOModalContainer mealsModalContainer addMealModal">
        <CommonHeadingNBtns
          title="Add Meal"
          onClose={closeModal}
          onClick={onSubmit}
          isLoading={loading}
        />
        <form className="formContainer">
          <div className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <label htmlFor="name" className={`formInputLabel `}>
                Name *
              </label>

              <input
                type="text"
                placeholder="Enter Meal Name"
                className={`formInput ${
                  mealFormErrors?.name ? "formError" : ""
                }`}
                name="name"
                value={mealForm.name}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label
                htmlFor="selectedRating"
                className={`formInputLabel ${
                  mealFormErrors?.selectedRating && "formError"
                }`}
              >
                Rating *
              </label>

              <div
                className={`commonWrapper ${
                  mealFormErrors?.selectedRating && "formError"
                }`}
              >
                <SelectDropdown
                  options={ratingOptions}
                  selectedOption={mealForm.selectedRating}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedRating")
                  }
                  name="Rating"
                />
              </div>

              {/* <input
            type="number"
            placeholder="Enter Meal Rating"
            className="formInput"
            name="rating"
            value={mealForm.rating}
            onChange={onChangeInput}
          /> */}
            </div>

            <div className="formInputBox">
              <label htmlFor="selectedCategory" className="formInputLabel">
                Diet Timing *
              </label>

              <div
                className={`commonWrapper ${
                  mealFormErrors?.selectedCategory && "formError"
                }`}
              >
                <SelectDropdown
                  options={allDropdown.mealCategories}
                  selectedOption={mealForm.selectedCategory}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedCategory")
                  }
                  name="Diet Timing"
                />
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="selectedUnit" className="formInputLabel">
                Unit *
              </label>

              <div
                className={`commonWrapper ${
                  mealFormErrors?.selectedUnit && "formError"
                }`}
              >
                <SelectDropdown
                  options={allDropdown.allUnits}
                  selectedOption={mealForm.selectedUnit}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedUnit")
                  }
                  name="Meal Unit"
                />
              </div>
            </div>

            <div className="formInputBox">
              <label
                htmlFor="protinGms"
                className={`formInputLabel ${
                  mealFormErrors?.protinGms && "formError"
                }`}
              >
                Protein (grams) *
              </label>

              <input
                type="number"
                placeholder="Enter Protein in Grams"
                className={`formInput ${
                  mealFormErrors?.protinGms ? "formError" : ""
                }`}
                name="protinGms"
                value={mealForm.protinGms}
                onChange={onChangeInput}
                min={0}
              />
            </div>

            <div className="formInputBox">
              <label
                htmlFor="protinCal"
                className={`formInputLabel ${
                  mealFormErrors?.protinCal ? "formError" : ""
                }`}
              >
                Protein (cal) *
              </label>

              <input
                type="number"
                placeholder="Enter Protein in Cal"
                className={`formInput ${
                  mealFormErrors?.protinCal ? "formError" : ""
                }`}
                name="protinCal"
                value={mealForm.protinCal}
                onChange={onChangeInput}
                min={0}
              />
            </div>

            <div className="formInputBox">
              <label
                htmlFor="carbsGms"
                className={`formInputLabel ${
                  mealFormErrors?.carbsGms && "formError"
                }`}
              >
                carbs (grams) *
              </label>

              <input
                type="number"
                placeholder="Enter Carbs in Grams"
                className={`formInput ${
                  mealFormErrors?.carbsGms ? "formError" : ""
                }`}
                name="carbsGms"
                value={mealForm.carbsGms}
                onChange={onChangeInput}
                min={0}
              />
            </div>

            <div className="formInputBox">
              <label
                htmlFor="carbsCal"
                className={`formInputLabel ${
                  mealFormErrors?.carbsCal ? "formError" : ""
                }`}
              >
                carbs (cal) *
              </label>

              <input
                type="number"
                placeholder="Enter Carbs in Cal"
                className={`formInput ${
                  mealFormErrors?.carbsCal ? "formError" : ""
                }`}
                name="carbsCal"
                value={mealForm.carbsCal}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label
                htmlFor="fatGms"
                className={`formInputLabel ${
                  mealFormErrors?.fatGms ? "formError" : ""
                }`}
              >
                Fat (grams) *
              </label>

              <input
                type="number"
                placeholder="Enter Fat in Grams"
                className={`formInput ${
                  mealFormErrors?.fatGms ? "formError" : ""
                }`}
                name="fatGms"
                value={mealForm.fatGms}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label
                htmlFor="fatCal"
                className={`formInputLabel ${
                  mealFormErrors?.fatCal ? "formError" : ""
                }`}
              >
                Fat (cal) *
              </label>

              <input
                type="number"
                placeholder="Enter Fat in Cal"
                className={`formInput ${
                  mealFormErrors?.fatCal ? "formError" : ""
                }`}
                name="fatCal"
                value={mealForm.fatCal}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label
                htmlFor="totalCalories"
                className={`formInputLabel ${
                  mealFormErrors?.totalCalories && "formError"
                }`}
              >
                total calories *
              </label>

              <input
                type="number"
                placeholder="Enter Total Calories"
                className={`formInput ${
                  mealFormErrors?.totalCalories ? "formError" : ""
                }`}
                name="totalCalories"
                value={mealForm.totalCalories}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox span4">
              <label htmlFor="selectedIngredients" className="formInputLabel">
                Ingredients
              </label>

              <div className="flexBetween">
                <div
                  className={`commonWrapper multiSelect ${
                    mealFormErrors?.selectedIngredients ? "formError" : ""
                  }`}
                >
                  <MultiSelect
                    options={allDropdown.allIngredients}
                    state={mealForm.selectedIngredients}
                    setState={(selectedValue) =>
                      setMealForm((prevs) => ({
                        ...prevs,
                        selectedIngredients: selectedValue,
                      }))
                    }
                    name="selectedIngredients"
                  />
                </div>

                <button
                  type="button"
                  className="btn btn-dark extraBtn"
                  style={{
                    minWidth: "150px",
                    height: "60px",
                    textTransform: "capitalize",
                  }}
                  onClick={() => setIngModal(true)}
                >
                  Add more
                </button>
              </div>
            </div>

            <>
              {/* {mealForm.ingredients.map((ingredient, index) => (
              <div key={ingredient.id} className="formInputBox">
                <label htmlFor="selectedIngredient" className="formInputLabel">
                  Ingredients {index + 1} *
                </label>

                <div
                  className={`commonWrapper ${
                    mealFormErrors?.selectedIngredient?.[index]
                      ? "formError"
                      : ""
                  }`}
                >
                  <SelectDropdown
                    options={mealCategories}
                    selectedOption={ingredient.selectedIngredient}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdownArray(selectedValue, index)
                    }
                    name={`Ingredients ${index + 1}`}
                  />
                </div>
              </div>
            ))} */}

              {/* <div className={`extraBtnWrapper`}>
            <button
              type="button"
              className="btn btn-dark extraBtn"
              onClick={addMoreIngredient}
            >
              + Add more
            </button>
          </div> */}
            </>
          </div>

          <div className="formInputsGrid textareaGridContainer">
            <div className="formInputBox">
              <label htmlFor="description" className="formInputLabel">
                Description *
              </label>

              <div className="commonWrapper textAreaCommonWrapper withAvgHeight">
                <ReactQuill
                  id="description"
                  name="description"
                  className={`formInput ${
                    mealFormErrors?.description ? "formError" : ""
                  }`}
                  placeholder="Enter Description"
                  value={mealForm.description}
                  onChange={(content) =>
                    onChangeTextInput(content, "description")
                  }
                />
              </div>
              {/* <textarea
              name="description"
              className={`formInput ${
                mealFormErrors?.description && "formError"
              }`}
              placeholder="Write something"
              value={mealForm.description}
              onChange={onChangeInput}
            ></textarea> */}
            </div>

            <div className="formInputBox">
              <label htmlFor="method" className="formInputLabel">
                Method *
              </label>

              <div className="commonWrapper textAreaCommonWrapper withAvgHeight">
                <ReactQuill
                  id="method"
                  name="method"
                  className={`formInput ${
                    mealFormErrors?.method ? "formError" : ""
                  }`}
                  placeholder="Enter Method"
                  value={mealForm.method}
                  onChange={(content) => onChangeTextInput(content, "method")}
                />
              </div>

              {/* <textarea
              name="method"
              className={`formInput ${mealFormErrors?.method && "formError"}`}
              placeholder="Write something"
              value={mealForm.method}
              onChange={onChangeInput}
            ></textarea> */}
            </div>
          </div>

          <div className="formInputsGrid uploadsInputGrids">
            <div className="formInputBox formInputUploadBox">
              <label htmlFor="thumbnailImg" className="formInputLabel">
                Thumbnail *
              </label>

              <div
                className={`commonWrapper commonUploadWrapper no-border ${
                  mealFormErrors?.thumbnailImg && "formError"
                }`}
                style={{ height: "auto" }}
              >
                <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="49"
                      height="49"
                      viewBox="0 0 49 49"
                      fill="none"
                    >
                      <path
                        d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                        fill="#A5A5A5"
                      />
                      <path
                        d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                        fill="#A5A5A5"
                      />
                    </svg>
                  </div>
                  <div className="image">
                    <ImageUploading
                      multiple
                      value={mealFormImages.thumbnailImg}
                      onChange={(imageList, addUpdateIndex) =>
                        onChangeImages(imageList, "thumbnailImg")
                      }
                      maxNumber={maxNumber}
                      dataURLKey="data_url"
                    >
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                      }) => (
                        <div className="upload__image-wrapper">
                          {mealFormImages.thumbnailImg?.length === 0 ? (
                            <>
                              <button
                                type="button"
                                style={
                                  isDragging ? { color: "red" } : undefined
                                }
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Upload
                              </button>
                              &nbsp;
                            </>
                          ) : (
                            <>
                              {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                  <img
                                    src={image["data_url"]}
                                    alt=""
                                    width="100"
                                  />
                                  <div className="image-item__btn-wrapper">
                                    <button
                                      type="button"
                                      onClick={() => onImageUpdate(index)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-cloud-plus"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                        />
                                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => onImageRemove(index)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-x"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      )}
                    </ImageUploading>
                  </div>
                </div>
              </div>
            </div>

            <div className="formInputBox formInputUploadBox">
              <label htmlFor="coverImg" className="formInputLabel">
                cover image *
              </label>

              <div
                className={`commonWrapper commonUploadWrapper no-border ${
                  mealFormErrors?.coverImg && "formError"
                }`}
                style={{ height: "auto" }}
              >
                <div
                  className={`icon-upload-btn createIncentiveCategoryForImageUpload`}
                >
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="49"
                      height="49"
                      viewBox="0 0 49 49"
                      fill="none"
                    >
                      <path
                        d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                        fill="#A5A5A5"
                      />
                      <path
                        d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                        fill="#A5A5A5"
                      />
                    </svg>
                  </div>
                  <div className="image">
                    <ImageUploading
                      multiple
                      value={mealFormImages.coverImg}
                      onChange={(imageList, addUpdateIndex) =>
                        onChangeImages(imageList, "coverImg")
                      }
                      maxNumber={maxNumber}
                      dataURLKey="data_url"
                    >
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                      }) => (
                        <div className="upload__image-wrapper">
                          {mealFormImages.coverImg?.length === 0 ? (
                            <>
                              <button
                                type="button"
                                style={
                                  isDragging ? { color: "red" } : undefined
                                }
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Upload
                              </button>
                              &nbsp;
                            </>
                          ) : (
                            <>
                              {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                  <img
                                    src={image["data_url"]}
                                    alt=""
                                    width="100"
                                  />
                                  <div className="image-item__btn-wrapper">
                                    <button
                                      type="button"
                                      onClick={() => onImageUpdate(index)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-cloud-plus"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                        />
                                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => onImageRemove(index)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-x"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      )}
                    </ImageUploading>
                  </div>
                </div>
              </div>
            </div>

            <div className="formInputBox formInputUploadBox">
              <label htmlFor="video" className="formInputLabel">
                video *
              </label>

              <div
                className={`commonWrapper commonUploadWrapper no-border ${
                  mealFormErrors?.video && "formError"
                }`}
              >
                <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="49"
                      height="49"
                      viewBox="0 0 49 49"
                      fill="none"
                    >
                      <path
                        d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                        fill="#A5A5A5"
                      />
                      <path
                        d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                        fill="#A5A5A5"
                      />
                    </svg>
                  </div>
                  <div className="image video">
                    <CustomizedDropzon
                      message={"Drag & drop video files here"}
                      onDrop={handleVideoDrop}
                      clearVideo={() =>
                        setMealFormImages((prevImages) => ({
                          ...prevImages,
                          video: [],
                        }))
                      }
                    />
                    <>
                      {/* <VideoUploading
                      multiple
                      value={mealFormImages.video}
                      onChange={onChangeVideos}
                      maxNumber={maxNumber}
                      dataURLKey="data_url"
                    >
                      {({
                        videoList,
                        onVideoUpload,
                        onVideoRemoveAll,
                        onVideoUpdate,
                        onVideoRemove,
                        isDragging,
                        dragProps,
                      }) => (
                        <div className="upload__image-wrapper upload__video-wrapper">
                          {mealFormImages.video.length === 0 ? (
                            <>
                              <button
                                type="button"
                                style={
                                  isDragging ? { color: "red" } : undefined
                                }
                                onClick={onVideoUpload}
                                {...dragProps}
                              >
                                Upload
                              </button>
                              &nbsp;
                            </>
                          ) : (
                            <>
                              {videoList.map((video, index) => (
                                <div key={index} className="video-item">
                                  <div className="video-item__btn-wrapper">
                                    <button
                                      type="button"
                                      onClick={() => onVideoUpdate(index)}
                                    >
                                      Update
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => onVideoRemove(index)}
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      )}
                    </VideoUploading> */}
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <>
            {/* <div className="formInputsGrid singleGridSystem">
          <div className="formInputBox formInputUploadBox">
            <label htmlFor="gym" className="formInputLabel">
              video
            </label>

            <div
              className={`commonWrapper commonUploadWrapper ${
                mealFormErrors?.isPopular ? "formError" : ""
              }`}
            >
              <CustomizedDropzon setState={setMealFormImages} />
            </div>
          </div>
        </div> */}
          </>

          <div className="formInputsGrid switchInputs">
            <div className="formInputBox formInputSwitchBox">
              <div
                className={`commonWrapper commonSwitchWrapper no-border ${
                  mealFormErrors?.isActive && "formError"
                }`}
              >
                <Form.Check
                  type="switch"
                  name="isActive"
                  label={`${mealForm.isActive ? "Active" : "Not Active"}`}
                  checked={mealForm.isActive}
                  onChange={onChangeInput}
                />
              </div>
            </div>

            <div className="formInputBox formInputSwitchBox">
              <div
                className={`commonWrapper commonSwitchWrapper no-border ${
                  mealFormErrors?.isPopular && "formError"
                }`}
              >
                <Form.Check
                  type="switch"
                  name="isPopular"
                  label={`${mealForm.isPopular ? "Popular" : "Not Popular"}`}
                  checked={mealForm.isPopular}
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateMealForm;
